import React from 'react';

import { cn } from '@/lib/utils';

function TabPaper({ children, className, ...props }: React.ComponentProps<'div'>): React.JSX.Element {
    return (
        <div className={cn('border-border bg-card rounded-b-xl border p-5', className)} {...props}>
            {children}
        </div>
    );
}

export default TabPaper;
